export default __webpack_public_path__ + "static/media/blaze_ecom_block_logo.66f900ac.svg";